import { Component } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-validator',
  template: '',
  styles: []
})
export class ValidatorComponent {
  dateFormat = 'DD-MM-YYYY';
  hidePassword = true;
  hideConfirmPassword = true;
  hideCurrentPassword = true;

  restrictToNumbers(event: KeyboardEvent) {
    const input = event.key;
    const currentValue = (event.target as HTMLInputElement).value;
    const proposedValue = currentValue + input;
    const validNumberPattern = /^[0-9]+\.?[0-9]*$/;
    if (
      !validNumberPattern.test(proposedValue) &&
      !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(input)
    ) {
      event.preventDefault();
    }
  }

  restrictToStrings(event: KeyboardEvent) {
    const input = event.key;
    if (!/^[a-zA-Z\s]$/.test(input) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(input)) {
      event.preventDefault();
    }
  }
  onStandardisedCalendarDateSelect(e: any, control: string, index: any, key: any) {
    const date = moment(e).format(this.dateFormat);
    (this as any)[control].controls[index].controls[key].setValue(date);
  }

  showCurrentPasswordToggle() {
    this.hideCurrentPassword = !this.hideCurrentPassword;
  }
  showPasswordToggle() {
    this.hidePassword = !this.hidePassword;
  }
  showConfirmPasswordToggle() {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }

  uppercaseValidator() {
    return (control: { value: string }) => {
      const hasUppercase = /[A-Z]/.test(control.value);
      return hasUppercase ? null : { uppercase: true };
    };
  }

  abnStatusCheck() {
    return (control: { value: string }) => {
      return control.value?.toLowerCase() === 'active' ? null : { inactive: true };
    };
  }

  lowercaseValidator() {
    return (control: { value: string }) => {
      const hasLowercase = /[a-z]/.test(control.value);
      return hasLowercase ? null : { lowercase: true };
    };
  }

  numberValidator() {
    return (control: { value: string }) => {
      const hasNumber = /[0-9]/.test(control.value);
      return hasNumber ? null : { number: true };
    };
  }

  specialCharacterValidator() {
    return (control: { value: string }) => {
      const hasSpecialCharacter = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(control.value);
      return hasSpecialCharacter ? null : { specialCharacter: true };
    };
  }

  noSpacesValidator() {
    return (control: { value: string }) => {
      if (/\s/.test(control.value)) {
        return { hasSpace: true };
      }
      return null;
    };
  }

  stateShortCuts(state: string) {
    switch (state) {
      case 'New South Wales':
        return 'NSW';
      case 'Victoria':
        return 'VIC';
      case 'Queensland':
        return 'QLD';
      case 'South Australia':
        return 'SA';
      case 'Western Australia':
        return 'WA';
      case 'Tasmania':
        return 'TAS';
      case 'Australian Capital Territory':
        return 'ACT';
      case 'Northern Territory':
        return 'NT';
      default:
        return this.convertToInitials(state);
    }
  }

  convertToInitials(value: any) {
    if (!value) return value;
    const words = value.split(' ');
    let initials = [];
    if (words.length > 1) {
      initials = words.map((word: any) => word.charAt(0));
    } else {
      initials = words.map((word: any) => word.slice(0, 3));
    }
    return initials.join('').toUpperCase();
  }

  convertToService(value: any) {
    switch (value) {
      case 'Physiotherapist':
        return 'Physiotherapy';
      default:
        return value;
    }
  }
}
